import { initializeApp } from "firebase/app";
import {getFirestore}  from "firebase/firestore"




const firebaseConfig = {
  apiKey: "AIzaSyB6RbHhXExfWBHSupAEYu8ladAdVQVQfPI",
  authDomain: "satyam-portfoilo.firebaseapp.com",
  projectId: "satyam-portfoilo",
  storageBucket: "satyam-portfoilo.appspot.com",
  messagingSenderId: "715530736896",
  appId: "1:715530736896:web:b20481d386f13a99220fe5"
};

 export const app = initializeApp(firebaseConfig);

export const db = getFirestore() 